import { render, staticRenderFns } from "./PrdtName.vue?vue&type=template&id=2beff8e0&"
import script from "./PrdtName.vue?vue&type=script&lang=js&"
export * from "./PrdtName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports